<div id="wrapper">
  <div class="page-title">
    <div class="tf-tsparticles">
      <div id="tsparticles1" data-color="#fff" data-line="#fff"></div>
    </div>
    <div class="tf-container">
      <div class="row">
        <div class="col-12">
          <div class="content">
            <h1 class="title">Contact us</h1>
            <ul class="breadcrumbs">
              <li>Contact</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="main-content">
    <section class="s-send-message tf-spacing-1">
      <div class="tf-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="heading-section">
              <h2 class="title">
                Send us a message
              </h2>
              <p class="sub-title">
                Our team of lottery experts is prepared to provide a quick and thorough <br>
                response to
                all your questions and concerns via
                email.
              </p>
            </div>
          </div>
          <div class="col-lg-12">
            <form class="form-add-message " data-wow-delay="0s" [formGroup]="contactUsForm">
              <div class="cols">
                <fieldset class="tf-field">
                  <label for="yourName">Your name</label>
                  <input class="tf-input" type="text" id="yourName" placeholder="Your name" formControlName="yourName">
                </fieldset>
                <fieldset>
                  <label for="yourEmail">Email address</label>
                  <input type="email" id="yourEmail" placeholder="Your email" formControlName="yourEmail">
                </fieldset>
              </div>
              <fieldset class="fieldText mb-30">
                <label for="yourMessage">Your message</label>
                <textarea id="yourMessage" placeholder="Your message" formControlName="yourMessage"></textarea>
              </fieldset>
              <div class="btn-send-comment flex justify-center">
                <button type="button" class="btn-send tf-btn " (click)="submitMessage()">Send mesage <i
                    class="icon-right"></i></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
